import React, { useEffect, useRef, useState } from "react";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

import Box from "../../Box";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    title: { display: false },
    tooltip: {
      backgroundColor: '#1A1530',
      padding: 10,
      cornerRadius: 8,
      displayColors: false,
      titleFont: { family: 'Inter', size: 12 },
      bodyFont: { family: 'Inter', size: 13, weight: '600' },
    }
  },
  scales: {
    x: {
      border: { display: false },
      grid: { display: false },
      ticks: { color: '#7A7499', font: { family: 'Inter', size: 12 } },
    },
    y: {
      beginAtZero: true,
      border: { display: false },
      grid: { color: '#EEECF7' },
      ticks: { color: '#7A7499', font: { family: 'Inter', size: 12 }, precision: 0 },
    },
  },
};

const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

export const BoxVerticalBarChart = ({ totalByMonth, title }) => {
  const chartRef = useRef(null);
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    getChartData();
  }, [totalByMonth]);

  const getChartData = () => {
    let labels = [];
    let data = [];
    totalByMonth.map(total => {
      labels.push(`${months[total.month - 1]}/${String(total.year).slice(2)}`);
      data.push(total.count);
    });

    const makeGradient = () => {
      const chart = chartRef.current;
      if (!chart) return 'rgba(77, 61, 171, 0.85)';
      const { ctx, chartArea } = chart;
      if (!chartArea) return 'rgba(77, 61, 171, 0.85)';
      const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
      gradient.addColorStop(0, 'rgba(123, 111, 204, 0.55)');
      gradient.addColorStop(1, 'rgba(77, 61, 171, 0.95)');
      return gradient;
    };

    let toChartData = {
      labels,
      datasets: [
        {
          label: 'Total',
          data,
          backgroundColor: makeGradient,
          hoverBackgroundColor: '#E84C4E',
          borderRadius: 8,
          borderSkipped: false,
          maxBarThickness: 48,
        },
      ],
    };

    setChartData(toChartData);
  }

  return (
    <Box title={title}>
      <div className="bar-chart">
        {chartData !== null &&
          <Bar ref={chartRef} options={options} data={chartData} />
        }
      </div>
    </Box>
  );
}

export default BoxVerticalBarChart;
